module.exports = __webpack_public_path__ + "img/kpdf-2.535a4156.jpg";